module.exports = __webpack_public_path__ + "img/Facebook.27f21337.png";